<template>
  <div>
    <van-image
      width="100%"
      height="97px"
      class="navbar-img"
      :src="require('@/assets/navbar.png')"
    />
    <div class="nav-ul">
      <a
        class="nav-li"
        v-for="(item, index) in navList"
        :key="index"
        :href="'https://kjpd.kepuchina.cn/' + item.url"
      >
        <span>
          {{ item.name }}
        </span></a
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "ClassList",
  components: {},
  props: {},
  data() {
    return {
      navList: [
        { name: "首页", url: "" },
        { name: "科学原理一点通", url: "2/" },
        { name: "智慧实验室", url: "3/" },
        { name: "科学通识", url: "4/" },
        { name: "云游科技馆", url: "5/" },
        { name: "大学之前", url: "6/" },
        { name: "名家讲坛", url: "7/" },
        { name: "拒绝emo", url: "8/" },
      ],
    };
  },
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.nav-ul {
  position: relative;
  width: 1200px;
  padding-top: 34px;
  margin: auto;
  font-size: 20px;
  color: white;

  .nav-li {
    color: white;
    cursor: pointer;
  }

  .nav-li + .nav-li {
    margin-left: 64px;
  }
}

.navbar-img {
  position: absolute;
  top: 0;
  left: 0;
}
</style>
